<div class="flex flex-col gap-5 p-5">
  <div class="p-4">
    <table>
      <tbody>
        <tr>
          <td class="font-semibold p-1 pr-8">Instructor</td>
          <td class="text-slate-400">{{request().instructor.fullname}}</td>
        </tr>
        <tr>
          <td class="font-semibold p-1 pr-8">Payment Method</td>
          <td class="text-slate-400">{{request().payment_method}}</td>
        </tr>
        <tr>
          <td class="font-semibold p-1 pr-8">Total Amount</td>
          <td class="text-slate-400">{{request().amount | currency:request().currency_symbol}}</td>
        </tr>
        <tr>
          <td class="font-semibold p-1 pr-8">Status</td>
          <td class="text-slate-400">{{request().status}}</td>
        </tr>
        <tr>
          <td class="font-semibold p-1 pr-8">Receipt</td>
          <td class="text-sm">
            @if (request().receipt) {
              <a class="text-primary underline" [href]="request().receipt" target="_blank">Click to download</a>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="p-4 flex flex-col bg-slate-50 gap-10">
    <div class="flex flex-col gap-5">
      <h6 class="font-semibold text-lg">Beneficiary Details</h6>
      <div>
        <table>
          <tbody>
            @if (request().beneficiary_and_payment_gateway_details.beneficiary_name) {
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Beneficiary Name:</td>
                <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.beneficiary_name}}</td>
              </tr>
            }
            @if (request().beneficiary_and_payment_gateway_details.country) {
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Beneficiary Country:</td>
                <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.country}}</td>
              </tr>
            }
            <tr>
              @if (request().beneficiary_and_payment_gateway_details.email) {
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Beneficiary email:</td>
              }
              <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    @if (request().payment_method === 'bank_account') {
      <div class="flex flex-col gap-5">
        <h6 class="font-semigobold text-lg">Bank Details</h6>
        <div>
          <table>
            <tbody>
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Bank Name</td>
                <td class="text-slate-400">{{ request().beneficiary_and_payment_gateway_details | thkActorFullname:{fields: ['first_name_in_bank', 'last_name_in_bank']} }}</td>
              </tr>
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Bank Address</td>
                <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.address}}</td>
              </tr>
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">Bank Country</td>
                <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.country}}</td>
              </tr>
              <tr>
                <td class="font-semibold p-1 w-40 max-w-[200px] min-w-[180px]">SWIFT/BIC Code</td>
                <td class="text-slate-400">{{request().beneficiary_and_payment_gateway_details.swift_code}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  <div class="p-4 flex flex-col gap-5">
    <h6>Post Activities</h6>
    <div class="activities">
      <div class="flex flex-col">
        @for (event of request().history; track event; let last = $last) {
          <div class="flex gap-6">
            <div class="flex flex-col">
              <thk-avatar [title]="event.actor.fullname" [url]="event.actor.avatar"></thk-avatar>
              @if (!last) {
                <div class="relative w-full flex-1">
                  <div class="absolute h-full translate-x-[-50%] left-[50%] w-[1px] border-l-2 border-l-slate-300"></div>
                </div>
              }
            </div>
            <div class="flex flex-col gap-3 pb-2">
              <div class="flex gap-1">
                <span class="text-md font-bold text-slate-500">{{actionTitles[event.action] || event.action}}</span>
                <span class="text-md font-bold">{{event.actor.fullname}}</span>
                <span class="text-md font-bold text-slate-500">.</span>
                <span class="text-slate-400">{{event.created_at | date:'dd MMMM, YYYY'}}</span>
              </div>
              <div class="mr-4 flex flex-col">
                <table>
                  <tbody>
                    @if (event.action === 'requested') {
                      <tr>
                        <td>Requested amount</td>
                        <td>: {{ event.data.requested_amount | currency:request().currency_symbol }}</td>
                      </tr>
                    }
                    @if (event.action !== 'requested') {
                      <tr>
                        <td>Released amount</td>
                        <td>: {{ event.data.processed_amount | currency:request().currency_symbol }}</td>
                      </tr>
                    }
                    <tr>
                      <td>Payment method</td>
                      <td>: {{ event.data.payment_method }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
